import React from 'react';
import PropTypes from 'prop-types';

function LeftStick({ active, activeColor, color }) {
  return (
    <path
      d="M279.026 376.503C295.231 376.503 308.367 363.367 308.367 347.163C308.367 330.958 295.231 317.822 279.026 317.822C262.822 317.822 249.685 330.958 249.685 347.163C249.685 363.367 262.822 376.503 279.026 376.503Z"
      fill={active ? activeColor : color}
    />
  );
}

LeftStick.propTypes = {
  active: PropTypes.bool,
  activeColor: PropTypes.string,
  color: PropTypes.string,
};

LeftStick.defaultProps = {
  active: false,
  activeColor: '#FFFFFF',
  color: '#1F2227',
};

export default LeftStick;
